import React from 'react';
import Script from 'next/script';

import type { PageAppDataLayer, Stage } from 'corgi-types';
import { useGTMConfig } from 'corgi/common/components/GTM';
import GtmNoScript from 'corgi/gtm-noscript/components/GtmNoscript';
import { getDataLayerScriptWithNavigationSupport } from 'frontend-utils';

interface GTMScriptsProps {
  id: string;
  dataLayer: PageAppDataLayer;
  stage: Stage;
  withScripts: boolean;
  events?: object[];
}

export const GTMScripts = ({ id, dataLayer, stage, withScripts, events = [] }: GTMScriptsProps) => {
  const { src } = useGTMConfig(stage);

  // There's important part of reordering events to keep initial Data Layer as the first one.
  // See "getDataLayerScriptWithNavigationSupport" docs for more details.
  return (
    <>
      <Script id={`initial-datalayer-${id}`}>
        {getDataLayerScriptWithNavigationSupport([dataLayer, ...events])}
      </Script>
      {withScripts && (
        <>
          <Script src={src.global} />
          <GtmNoScript environment={stage} />
          <Script src={src.region} />
        </>
      )}
    </>
  );
};
